export const search_list = [
  {
    type: "input",
    label: "公司名称",
    props: "company_name",
  },
];

export const tableColumns = [
  {
    title: "企业名称",
    value: "company_name",
    header_align: 'center',
    align: 'center',
  },
  {
    title: "统一社会信用代码",
    value: "taxpayer",
    header_align: 'center',
    align: 'center',
  },
  {
    title: "负责人",
    value: "contact",
    header_align: 'center',
    align: 'center',
  },
  {
    title: "负责人联系电话",
    value: "contact_phone",
    header_align: 'center',
    align: 'center',
  },
  {
    title: "审核状态",
    value: "examine_status_text",
    header_align: 'center',
    align: 'center',
    width: 100
  },
];
export const actionGroup = [
  {
    name: "审核",
    flag: "examine",
    rules:'examine_status==0',
  }
];
